<template>
    <transition name="fade">
        <div class="modal__wrapper" v-show="isOpen" @click.self="close" ref="wrapper"
            v-touch:swipe="swipeHandler"
            v-touch:start="startHandler"
            v-touch:moving="movingHandler"
            v-touch:end="endHandler"
            :style='wrapperStyles()'
            :class="classes"
            >
            <transition name="slide-left">
                <div class="modal" v-show="isOpen" ref="modal" :style="styles" :class="classes">
                    <figure class="modal__image" :style="{ backgroundImage: `url(${image})` }" alt=""></figure>
                    <button class="modal__close is-left" @click="close"></button>

                    <div class="modal__content frame-medium">
                        <span v-if="diet" class="modal__diet">{{ diet.title }}</span>

                        <h3 class="modal__title">{{ title }}</h3>
                        <p v-if="detail" class="modal__description remove-b-margin">{{ detail }}</p>
                        <ul v-if="notes" class="modal__info-list list-reset">
                            <li>
                                {{ notes }}
                            </li>
                        </ul>

                        <!-- <div class="modal__properties">
                            <span v-if="breadUnits">{{bclang("Broteinheiten")}}: {{ breadUnits }}</span>
                            <span v-if="kcals">{{bclang("Kcals")}}: {{ kcals }}</span>
                            <span v-if="CO2">{{bclang("CO2")}}: {{ CO2 }}</span>
                        </div> -->

                        <div v-show="(intolerances && intolerances.length)" class="modal__info is-inline">
                            <h3 class="modal__info-title">{{ bclang("Enthält") }}:</h3>

                            <ul class="modal__info-list list-reset">
                                <li v-for="int in intolerances" :key="int.key">
                                    {{ int.title }}
                                </li>
                            </ul>
                        </div>

                        <p v-if="station" class="modal__info modal__info-station remove-b-margin">
                            <span class="modal__info-station-label">{{ bclang('Das Gericht finden Sie hier') }}:</span>
                            <span class="modal__info-station-title">{{ station.label ? `${station.label} / ` : '' }}{{ station.title }}</span>
                        </p>
                        <p class="modal__info-station remove-t-margin" v-if="data && data.station && data.station.sections">
                            <ul class="modal__info-station-title list-reset">
                                <li :key="label" v-for="section in data.station.sections" class="modal__info-station-title" >{{ section.title }}</li>
                            </ul>
                        </p>
                    </div>

                    <figure class="modal__map" v-if="(isOpen || initiatedMap) && sections && sections.length > 0" >
                        <!--                        <img class="modal__map-image" :src="station.map.default" alt="">-->
                        <Map :styleObject="mapStyleObject" :station="station" :sections="sections" :location="location" />
                    </figure>
                    <figure v-if="station && station.map" class="modal__map">
                        <img class="modal__map-image" :src="station.map.default" alt="">
                    </figure>
                </div>
            </transition>
        </div>
    </transition>
</template>

<script>
    import {wrapFunction} from '../js/utils.js';
    import clamp from 'lodash/clamp';
    import config from '../config.json';

    // not working yet
    import Map from "BerlinCuisineMap";

    const bodyScrollLock = require('body-scroll-lock');
    const disableBodyScroll = bodyScrollLock.disableBodyScroll;
    const enableBodyScroll = bodyScrollLock.enableBodyScroll;
    const enableSwipeToClose = false;

    export default {
        name: 'Modal',
        components: {
            Map
        },
        computed: Object.assign(wrapFunction(`
            title
            detail
            notes
            station
            diet
            intolerances
            CO2
            kcals
            breadUnits
            isOpen
        `), {
            styles() {
                return {
                    transform: this.transform,
                };
            },
            classes() {
                return {
                    'is-moving': this.isMoving,
                };
            },
        }),
        props: {
            data: Object,
            image: String,
            sections: Array,
            // location: Object,
        },
        watch: {
            isOpen(val) {
                val ? disableBodyScroll(this.$refs.wrapper,{
                  allowTouchMove: el => (el === this.$refs.modal),
                }) : enableBodyScroll(this.$refs.wrapper);
            },
        },
        methods: {
            wrapperStyles() {

                return {
                    background: `rgba(0,0,0, ${this.isOpen ? 1 - (this.moveProgress) : 0})`,
                };
            },
            close() {
                this.initiatedMap = true;
                this.$emit('close');
            },
            swipeHandler(direction) {
                if (!enableSwipeToClose) return;

                if (direction === 'right') {
                    this.close();
                }
            },
            startHandler(what) {
                if (!enableSwipeToClose) return;

                this.startX = what.touches[0].clientX;

                this.clamp = [
                    0,
                    this.$refs.wrapper.clientWidth,
                ];
            },
            movingHandler(what) {
                if (!enableSwipeToClose) return;

                this.isMoving = true;
                const [ min, max ] = this.clamp;
                this.distance = what.touches[0].clientX - this.startX;
                this.moveProgress = this.distance / this.$refs.wrapper.clientWidth
                this.transform = `translateX(${clamp(this.distance, min, max)}px)`;
            },
            endHandler(what) {
                if (this.moveProgress > 0.5) {
                    this.close();
                }
                this.startX = 0;
                this.distance = 0;
                this.moveProgress = 0;
                this.transform = '';
                this.isMoving = false;
            },
        },
        data() {
            return {
                config,
                isMoving: false,
                clamp: [],
                initiatedMap : false,
                startX: 0,
                distance: 0,
                moveProgress: 0.5,
                transform: '',
                mapStyleObject: {
                    height: "calc(70vh)"
                }
            };
        }
    }
</script>

<style lang="scss">

    @import '../scss/config';

    .modal {
        $close-size: rem(16);
        $icon-size: size(large);

        position: relative;
        width: 100%;
        background: color(background);
        // margin: auto; // https://stackoverflow.com/questions/33454533/cant-scroll-to-top-of-flex-item-that-is-overflowing-container

        &.is-moving {
            transition: none;
        }

        &__wrapper {
            position: fixed;
            top: 0;
            left: 0;
            z-index: 100;
            width: 100%;
            height: 100vh;
            background: color(background);
            overflow: scroll;
            scroll-behavior: smooth;
            -webkit-overflow-scrolling: touch;
            display: flex;
            align-items: flex-start;

            &.is-moving {
                transition: none;
            }
        }

        &__content {
            @include round-and-nudged();
            position: relative;
            background: color(background);

            p {

                &:last-of-type {
                    margin-bottom: 0;
                }
            }

            &::after {
                $size: 100%;
                content: '';
                display: block;
                position: absolute;
                top: 100%;
                left: 0;
                width: $size;
                height: 50%;
                background: linear-gradient(to bottom, color(background), color(background, $opacity: 0));
            }
        }

        &__diet {
            display: block;
            color: color(accent);
        }

        &__title {
            font-size: size(font-headline);
            margin-top: 0;
            margin-top: size(medium);
            margin-bottom: 0;
            line-height: 1;
        }

        &__description {
            @include font-regular();
            font-size: size(font-medium);
            position: relative;
            top: -(size(small));
        }
        &__properties {
            font-size: size(font-nano);
            position: relative;
            top: (size(tiny));
            span {
                display: block
            }
        }

        &__image {
            display: block;
            margin: 0;
            padding-bottom: 50%;
            width: 100%;
            height: 0;
            background-size: cover;
            background-position: center center;
        }

        &__map {
            display: block;
            margin: 0;
            width: 100%;

            &-image {
                width: 100%;
                vertical-align: middle;
            }
        }

        &__close {
            position: absolute;
            top: size(medium);
            left: size(medium);

            @include arrow-button((
                size: $close-size,
                length: $close-size * .66,
                color: color(accent),
                roundness: size(line),
                thickness: .1,
            ));
        }

        // TODO: just a hot fix
        &::before {
            $size: $close-size * 2;
            $padding: rem(7);
            content: '';
            display: block;
            position: absolute;
            top: $padding;
            right: $padding;
            width: $size;
            height: $size;
            background: faint-color(background, 0.5);
        }

        &__info {
            margin-top: size(medium);
            align-items: baseline;

            &.is-inline {
                display: flex;
            }

            &-title {
                font-size: size(font-tiny);
                margin-top: 0;
                margin-bottom: size(tiny);
                margin-right: .2em;
                color: color(accent);
            }

            &-list {
                @include font-regular();
            }

            &-station {

                position: relative;
                // color: color(accent-secondary);
                font-size: size(font-small);
                @include font-regular();

                &-label {
                    display: block;
                }

                &-title {
                    @include font-regular();
                    color: color(accent);
                    display: block;
                    font-size: size(font-medium);
                    margin-top: rem(2);
                }
            }

            &-icon {
                position: relative;
                display: inline-block;
                vertical-align: middle;
                margin-top: rem(1);
                margin-bottom: rem(1);
                transform: slide-right(1.3);

                &.is-accent {
                    color: color(accent);
                }

                &::after {
                    $size: 70%;
                    content: '';
                    display: block;
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: $size;
                    height: $size;
                    border: rem(1) solid currentColor;
                    border-radius: 50%;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                }
            }

            &-icon,
            &-svg,
            &-info {
                width: size(large) * 1.3;
                height: size(large) * 1.3;
                margin-right: size(small);
            }

            &-info {
                line-height: size(large) * 1.3;
                text-align: center;
                font-size: 1.6em;
                font-weight: 700;
                margin-top: rem(2);
                display: flex;
            }


            &-list {
                font-size: size(font-tiny);
                display: flex;
                flex-wrap: wrap;
                flex-shrink: 0;

                li {
                    color: color(accent);

                    & + li {

                        &::before {
                            content: ', ';
                            display: inline-block;
                        }
                    }
                }
            }
        }
    }
</style>
